import React, { useCallback } from 'react'
// import * as React from 'react';
import Slide from '@mui/material/Slide';
import "./AccessConfiguration.css";
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import EditableTable from "../../../../reUsableTemplates/EditableTable/EditableTable"
import mainicon from "../../../../../assets/global_assets/role_imgs/role-table-title-icon.png";

// import Modelform from '../modalForm/Modelform';
import CreatePermissionModal, { emptyPermission } from './CreatePermissison';
import table_edit_icon from "../../../../../assets/reUsableTemplates_assets/table_edit_icon.png";
import table_delete_icon from "../../../../../assets/reUsableTemplates_assets/table_delete_icon.png";
import { useDispatch } from "react-redux";
import { getRole, deleteRoleById, createRole, updateRoleById } from "./../../../../../services/global_redux/globale_actions/Role.action"
import { createPermission, getPermission, updatePermissionById, deletePermissionById, createAccessConfiguration } from "./../../../../../services/global_redux/globale_actions/Permission.action"
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import into_icon from "../../../../../assets/global_assets/create_data_imgs/into_icon.png";
import CreateCertificateTemplate from '../../../../global/Settings/modalForm/CreateCertificateTemplate';

// import CompressTable from './CompressTable';
// import CompressTable1 from './CompressTable1';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AccessConfiguration({ showSnackbar, setLoading }) {
  const [roleData, setRoleData] = React.useState([])
  const [permissionData, setPermissionData] = React.useState([])
  const [asignedPermissionData, setAsignedPermissionData] = React.useState([])
  const dispatch = useDispatch();
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [openroledeletealert, setopenroledeletealert] = useState(false);
  const [openUserdeletealert, setopenUserdeletealert] = useState(false);
  const [deleteroleid, setroledeleteid] = useState(null);
  const [deleteuserid, setuserdeleteid] = useState(null);
  const [roles, setroles] = useState(null);
  const [selectedModule, setSelectedModule] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [newSubmodule, setNewSubmodule] = useState("");
  const [showNewInputForId, setShowNewInputForId] = useState(null);
  const [createPermissionModalOpen, setCreatePermissionModalOpen] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [actionChecked, setActionChecked] = useState("");
  const [openCreate, setOpenCreate] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newPermission, setNewPermission] = useState({ ...emptyPermission });

  const header = [
    { key: "service", value: "Service", input: "text" },
    { key: "section", value: "Section", input: "text" },
    { key: "module", value: "Module", input: "text" },
    { key: "sub_module", value: "Sub Module", input: "text" },
  ];

  const handleFetchStates = async () => {
    try {
      const response = await dispatch(getRole());
      setRoleData(response.data);
      setroles(response.data)
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };

  useEffect(() => {
    handleFetchStates();
  }, [dispatch]);

  const deleteRole = async () => {
    setLoading(true);
    setopenroledeletealert(false);
    try {
      const response = await dispatch(deleteRoleById(deleteroleid));
      setRoleData(response.data);
      setLoading(false);
      showSnackbar(response.message);
      handleFetchStates()
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };

  const fetchPermission = useCallback(async () => {
    try {
      const response = await dispatch(getPermission());
      const perms = response?.data?.[0]?.permissions;
      const assigned = response?.data?.[1]?.assigned_permission;
      setPermissionData(Array.isArray(perms) ? perms : []);
      setAsignedPermissionData(Array.isArray(assigned) ? assigned : []);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchPermission();
  }, [dispatch]);

  const handleEditClick = (id) => {
    setEditableRow(id);
    const rowData = filteredPermissionData.find(item => item.id === id);
    setEditedValues({
      section: rowData.section,
      module: rowData.module,
      action: rowData.action,
      // clone sub_module so edits don't mutate the original array in place
      sub_module: Array.isArray(rowData.sub_module)
        ? rowData.sub_module.map((sub) => ({ ...sub }))
        : [],
    });
  }

  const handleSaveClick = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(
        updatePermissionById(id, [editedValues])
      );
      if (response.message) {
        showSnackbar(response.message, "success");
        setLoading(false);
        fetchPermission()
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };

  const handleCancelClick = () => {
    setEditableRow(null);
    setEditedValues({});
  };

  const handleDeleteClick = async () => {
    setLoading(true);
    setopenUserdeletealert(false);
    try {
      const response = await dispatch(deletePermissionById(deleteuserid));
      if (response.success) {
        showSnackbar(response.message, "success");
        setLoading(false);
        fetchPermission();
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };

  const handledeleteuserClickOpenalert = (id) => {
    setopenUserdeletealert(true);
    setuserdeleteid(id)
  };

  const handleuserdeleteClosealert = () => {
    setopenUserdeletealert(false);
  }

  const handleCloseCreatePermission = () => {
    setCreatePermissionModalOpen(false);
    setNewPermission({ ...emptyPermission });
  };

  const handleCreatePermission = async () => {
    if (!newPermission.section || !newPermission.module) {
      showSnackbar("Section and Module are required!","error");
      return;
    }
    setLoading(true);
    try {
      const response = await dispatch(createPermission(newPermission));      
      if (response.success === true) {
        showSnackbar(response.data?.message || "Permission created successfully", "success");
        setNewPermission({ ...emptyPermission });
        setCreatePermissionModalOpen(false);
        await fetchPermission();
      } else {
        showSnackbar(response.message, "warning");
      }
    } catch (err) {
    console.error(err);
    showSnackbar(
      typeof err === "string" ? err : "An unexpected error occurred.",
      "error"
    );
  } finally {
    setLoading(false);
  }
};

  // Filter table rows based on selected section & module
  const filteredPermissionData = permissionData.filter((item) => {
    const matchesSection = selectedSection ? item.section === selectedSection : true;
    const matchesModule = selectedModule ? item.module === selectedModule : true;
    return matchesSection && matchesModule;
  });

  const isReadOnly = (section, module, subModuleName) => {
    return asignedPermissionData.some(
      (assigned) =>
        assigned.section === section &&
        assigned.module === module &&
        Array.isArray(assigned.sub_module) &&
        assigned.sub_module.some((sub) => sub.name === subModuleName)
    );
  };

  // Distinct values for the filter dropdowns
  const uniqueSections = [...new Set(permissionData.map((item) => item.section).filter(Boolean))];
  const uniqueModules = [...new Set(permissionData.map((item) => item.module).filter(Boolean))];

  return (
    <div className="container-fluid py-3 access-config-page">
      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <div>
          <h4 className="mb-1">Permissions</h4>
        </div>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={() => {
            window.dispatchEvent(new Event("sidebar-close-menus"));
            navigate("/dashboard");
          }}
        >
          Back to Dashboard
        </button>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3 px-2">
        <div className="d-flex gap-2">
          <select
            className="form-select form-select-sm"
            style={{ minWidth: 160 }}
            value={selectedSection}
            onChange={(e) => setSelectedSection(e.target.value)}
          >
            <option value="">All Sections</option>
            {uniqueSections.map((section) => (
              <option key={section} value={section}>{section}</option>
            ))}
          </select>

          <select
            className="form-select form-select-sm"
            style={{ minWidth: 160 }}
            value={selectedModule}
            onChange={(e) => setSelectedModule(e.target.value)}
          >
            <option value="">All Modules</option>
            {uniqueModules.map((module) => (
              <option key={module} value={module}>{module}</option>
            ))}
          </select>
        </div>

        <button type="button" className="btn btn-primary btn-sm" onClick={() => {
          setNewPermission({ ...emptyPermission });
          setCreatePermissionModalOpen(true);
        }}>
          <b>Create Permission</b>
        </button>
      </div>

      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>SLNO</th>
                  <th>Section</th>
                  <th>Module</th>
                  <th>Sub Module</th>
                  <th className="text-center">Action</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredPermissionData.length > 0 ? (
                  filteredPermissionData.map((item, index) => {
                    const isEditing = editableRow === item.id;
                    const subModules = isEditing
                      ? (editedValues.sub_module || item.sub_module || [])
                      : (item.sub_module || []);
                    const subModulesCount = subModules.length > 0 ? subModules.length : 1;

                    return (
                      <React.Fragment key={item.id}>
                        {subModules.length > 0 ? (
                          subModules.map((sub, i) => {
                            const readOnly = isReadOnly(item.section, item.module, sub.name);

                            return (
                              <tr key={`${item.id}-${i}`}>
                                {i === 0 && (
                                  <>
                                    <td rowSpan={subModulesCount}>{index + 1}</td>
                                    <td rowSpan={subModulesCount}>
                                      {isEditing ? (
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={editedValues.section}
                                          onChange={(e) =>
                                            setEditedValues({ ...editedValues, section: e.target.value })
                                          }
                                          readOnly={readOnly}
                                        />
                                      ) : (
                                        item.section
                                      )}
                                    </td>
                                    <td rowSpan={subModulesCount}>
                                      {isEditing ? (
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={editedValues.module}
                                          onChange={(e) =>
                                            setEditedValues({ ...editedValues, module: e.target.value })
                                          }
                                          readOnly={readOnly}
                                        />
                                      ) : (
                                        item.module
                                      )}
                                    </td>
                                  </>
                                )}

                                <td>
                                  {isEditing ? (
                                    <div className="d-flex align-items-center">
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={sub.name}
                                        onChange={(e) => {
                                          const updated = [...editedValues.sub_module];
                                          updated[i] = { ...updated[i], name: e.target.value };
                                          setEditedValues({ ...editedValues, sub_module: updated });
                                        }}
                                        readOnly={readOnly}
                                      />
                                      <div className="form-check ms-2">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`sub-action-${item.id}-${i}`}
                                          disabled={(editedValues.action || item.action) !== "Yes" || readOnly}
                                          checked={sub.action === "Yes"}
                                          onChange={() => {
                                            const updated = [...editedValues.sub_module];
                                            updated[i] = {
                                              ...updated[i],
                                              action: updated[i].action === "Yes" ? "No" : "Yes",
                                            };
                                            setEditedValues({ ...editedValues, sub_module: updated });
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`sub-action-${item.id}-${i}`}
                                        >
                                          Yes
                                        </label>
                                      </div>
                                    </div>
                                  ) : (
                                    `${sub.name} (${sub.action})`
                                  )}
                                </td>

                                {i === 0 && (
                                  <>
                                    <td rowSpan={subModulesCount} className="text-center">
                                      {isEditing ? (
                                        <div className="form-check d-flex justify-content-center">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`module-action-${item.id}`}
                                            checked={(editedValues.action || item.action) === "Yes"}
                                            onChange={() => {
                                              const newAction =
                                                (editedValues.action || item.action) === "Yes" ? "No" : "Yes";

                                              // If toggling OFF, also uncheck all submodule actions
                                              const updatedSubModules = [
                                                ...(editedValues.sub_module || item.sub_module || []),
                                              ].map((sub) => ({
                                                ...sub,
                                                action: newAction === "Yes" ? sub.action : "No",
                                              }));

                                              setEditedValues({
                                                ...editedValues,
                                                action: newAction,
                                                sub_module: updatedSubModules,
                                              });
                                            }}
                                            disabled={readOnly}
                                          />
                                          <label
                                            className="form-check-label ms-1"
                                            htmlFor={`module-action-${item.id}`}
                                          >
                                            {(editedValues.action || item.action) === "Yes" ? "Yes" : "No"}
                                          </label>
                                        </div>
                                      ) : (
                                        item.action
                                      )}
                                    </td>
                                    <td rowSpan={subModulesCount} className="text-center">
                                      {isEditing ? (
                                        <div className="d-flex justify-content-center access-row-actions">
                                          <span
                                            onClick={() => handleSaveClick(item.id)}
                                            className="p-0"
                                          >
                                            <i className="bi bi-floppy2-fill text-success auction-btn" style={{ cursor: "pointer" }}></i>
                                          </span>
                                          <span
                                            onClick={handleCancelClick}
                                            className="p-0"
                                          >
                                            <i className="bi bi-x-circle text-info auction-btn" style={{ cursor: "pointer" }}></i>
                                          </span>
                                        </div>
                                      ) : (
                                        <div className="access-row-actions">
                                          <span
                                            onClick={() => handleEditClick(item.id)}
                                            className="p-0"
                                          >
                                            <div className="action_icon action_edit_icon">
                                              <img src={table_edit_icon} alt="Edit" className="edit_icon" />
                                            </div>
                                          </span>
                                          <span
                                            onClick={() => handledeleteuserClickOpenalert(item.id)}
                                            className="p-0"
                                          >
                                            <div className="action_icon action_delete_icon">
                                              <img src={table_delete_icon} alt="Delete" className="delete_icon" />
                                            </div>
                                          </span>
                                        </div>
                                      )}
                                    </td>
                                  </>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{item.section}</td>
                            <td>{item.module}</td>
                            <td>-</td>
                            <td className="text-center">{item.action}</td>
                            <td className="text-center">
                              <div className="access-row-actions">
                                <span
                                  onClick={() => handleEditClick(item.id)}
                                  className="p-0"
                                >
                                  <div className="action_icon action_edit_icon">
                                    <img src={table_edit_icon} alt="Edit" className="edit_icon" />
                                  </div>
                                </span>
                                <span
                                  onClick={() => handledeleteuserClickOpenalert(item.id)}
                                  className="p-0"
                                >
                                  <div className="action_icon action_delete_icon">
                                    <img src={table_delete_icon} alt="Delete" className="delete_icon" />
                                  </div>
                                </span>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <CreatePermissionModal
        show={createPermissionModalOpen}
        handleClose={handleCloseCreatePermission}
        newPermission={newPermission}
        setNewPermission={setNewPermission}
        handleCreatePermission={handleCreatePermission}
        permissionData={permissionData}
      />

      {/* Delete User Dialog */}
      <Dialog open={openUserdeletealert} TransitionComponent={Transition} keepMounted>
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this user? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleuserdeleteClosealert}>No</Button>
          <Button onClick={handleDeleteClick}>Yes</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Role Dialog */}
      <Dialog open={openroledeletealert} TransitionComponent={Transition} keepMounted>
        <DialogTitle>{"Are you sure?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this role? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setopenroledeletealert(false)}>No</Button>
          <Button onClick={deleteRole}>Yes</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AccessConfiguration
